import {Component, Inject, OnInit} from '@angular/core';
import {Location} from "@angular/common";
import {UtilsService} from "../../shared/utils.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DynamicFormsCategoriesFilter} from "./dynamic-forms-categories-filter.interface";

@Component({
  selector: 'app-dynamic-forms-categories-filter',
  templateUrl: './dynamic-forms-categories-filter.component.html',
  styleUrls: ['./dynamic-forms-categories-filter.component.scss']
})
export class DynamicFormsCategoriesFilterComponent implements OnInit {

  // Define the filter options.
  filter_options: DynamicFormsCategoriesFilter = {
    only_archived: 'false'
  };

  constructor(
    public location: Location,
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DynamicFormsCategoriesFilterComponent>
  ) {
    // set a default category of false if no values are passed through
    if (typeof this.data['only_archived'] == 'undefined') {
      this.data['only_archived'] = 'false';
    }
  }

  ngOnInit() {
    // The constructor makes sure the values are set and present.
    this.filter_options.only_archived = this.data['only_archived'];
  }

  /**
   * Clear the filter options and send the response back.
   */
  onClearAndClose() {
    // Clear all filter options.
    this.filter_options.only_archived = 'false';

    this.onSaveAndClose();
  }

  /**
   * Close the dialog and send the selected options as the response.
   */
  onSaveAndClose() {
    this.dialogRef.close(this.filter_options);
  }

}
